import { FormattedMessage } from 'react-intl';
import { Box } from '@theme-ui/components';

import Column from '@app/components/Grid/Column';
import Grid from '@app/components/Grid/Grid';
import { H2 } from '@app/components/typography';
import ProductTile from '@app/pages/ProductFinder/ProductTile';
import { ProductTileVariant } from '@app/pages/ProductFinder/ProductTile/ProductTile.types';
import type { Magento2_RestApi_Product } from '@__graphql__/types';

import messages from '../WhatsNewForMe.messages';

const IncludedProducts = ({
  products,
}: {
  products: Magento2_RestApi_Product[];
}) => {
  return (
    <Box data-testid="whats-new-included-products-catalog">
      <Box mb={3} sx={{ textAlign: 'center' }}>
        <H2 as="h1">
          <FormattedMessage {...messages.youllGet} />
        </H2>
      </Box>

      <Grid>
        {products.map((product) => (
          <Column span={[4, 2, 2, 3]} key={product.id}>
            <Box data-testid={`whats-new-product-${product.sku}`} py={4}>
              <ProductTile
                product={product}
                variant={ProductTileVariant.SIMPLE}
              />
            </Box>
          </Column>
        ))}
      </Grid>
    </Box>
  );
};

export default IncludedProducts;
